<template>
  <div id="app">
    <router-view
      v-if="showRouteView"
      :class="$i18n.locale.includes('zh') ? 'lang_zh' : 'lang_en'"
    />
    <audio src="/static/file/8855.mp3" id="promptTone">您的浏览器不支持 audio 标签。</audio>
    <ai-image-text-recognition-modal />
    <!-- 富文本编辑器中图片的操作按钮（全局，全屏状态下需要） -->
    <el-button-group class="img-attr-dialog" :style="imgAttrStyle" v-if="imgDialog">
      <el-button type="info" size="mini" plain @click="imgHandle(0)"
        ><i class="iconfont icon-suoxiao"></i
      ></el-button>
      <el-button type="info" size="mini" plain @click="imgHandle(1)">1:1</el-button>
      <el-button type="info" size="mini" plain @click="imgHandle(2)"
        ><i class="iconfont icon-fangda"></i
      ></el-button>
      <el-button type="info" size="mini" plain @click="imgHandle(3)"
        ><i class="iconfont icon-pc-delete"></i
      ></el-button>
    </el-button-group>
  </div>
</template>

<script>
  import toolCustom from '@/frontend/module/components/tool-cutom.js'
  import tool from '@/common/js/tool.js'
  import { employee } from '@/common/js/employee.js'
  import { baseURL, HTTPServer } from '@/common/js/ajax.js'
  import AiImageTextRecognitionModal from '@/common/components/ai-image-text-recognition-modal.vue'
  export default {
    name: 'App',
    components: {
      AiImageTextRecognitionModal
    },
    data() {
      return {
        showRouteView: false,
        imgAttrStyle: {}, // 富文本编辑器中图片的操作按钮动态样式
        imgDialog: false // 图片设置
      }
    },
    created() {
      let _this = this
      if (location.href.includes('formSetDesign')) {
        // 公文表单设计页面(因文件较大只在该页面加载)
        let arr = ['/static/js/ueditor.all.js', '/static/js/layui.js', '/static/js/zh-cn.js']
        let loadScript = (url, key) => {
          // 未加载，创建并加载新的script标签
          let script = document.createElement('script')
          script.src = url
          document.head.appendChild(script)
          script.onload = function () {
            if (key < 2) {
              loadScript(arr[key + 1], key + 1)
            } else {
              _this.showRouteView = true
            }
          }
        }
        loadScript(arr[0], 0)
      } else {
        const hash = window.location.hash || ''
        const query = hash.includes('?') ? hash.split('?')[1] : ''
        const paramsUrl = query ? new URLSearchParams(query) : new URLSearchParams()
        // 把 params 转换为对象
        const params = Object.fromEntries(paramsUrl)

        if (params.id && params.auth_token && params.source) {
          // params.id 代表公司ID，params.auth_token 代表第三方平台携带的token，params.source 代表来源（哪个第三方平台）
          // 这里是第三方平台携带token跳转业务详情的逻辑，先不直接显示路由组件，等处理完token登录逻辑后再显示
          this.showRouteView = false
        } else {
          this.showRouteView = true
        }
      }

      // 处理--第三方平台携带token跳转业务详情
      this.handleLoginByToken()
    },
    /* 页面加载后执行 */
    mounted() {
      // 华巨臣订阅事件监听， 2021-12-09
      // 有电话接入 -》 跳转自定义列表页面 -》 打开对应详情弹窗
      if (window.hjcConfig) {
        let script = document.createElement('script')
        script.src = './static/js/mqtt.min.js'
        script.language = 'javascript'
        script.type = 'text/javascript'
        var head = document.getElementsByTagName('head').item(0)
        head.appendChild(script)

        let dateTime = 0
        window.teamfaceCallback = res => {
          if (typeof res === 'string') {
            res = JSON.parse(res)
          } else {
          }
          if (res.Event.trim() === 'Popscreen' && res.CallType === 'in') {
            let newDate = new Date().getTime()
            if (newDate - dateTime > 1000) {
              dateTime = newDate
              let emid = tool.decryptMoney(localStorage.getItem('userInfo')).employeeInfo.emid
              if (emid && emid.includes('HJCZX')) {
                emid = emid.split('HJCZX')[1]
              }
              if (res.CalledNo === emid) {
                toolCustom.formatHjcCallevent(res) // 正式
              }
            }
          }
        }
      }
      /** 富文本编辑器图片显示 */
      this.$bus.off('show-img-attr-dialog')
      this.$bus.on('show-img-attr-dialog', (v, v2, v3) => {
        this.imgDialog = v2
        this.imgAttrStyle = v
        this.kindId = v3
      })

      if (localStorage.getItem('userInfo')) {
        try {
          setTimeout(() => {
            let userInfo = tool.decryptMoney(localStorage.getItem('userInfo'))
            if (
              userInfo.companyInfo &&
              userInfo.companyInfo.company_name &&
              userInfo.companyInfo.company_name !== 'undefined'
            ) {
              document.title = userInfo.companyInfo.company_name
            }
          }, 10)
        } catch (error) {}
      }
    },
    methods: {
      // 富文本编辑器图片按钮点击操作
      imgHandle(type) {
        // type 0 缩小，1 等比，2 放大， 3 删除
        this.$bus.emit('img-attr-handle', type, this.kindId)
      },
      // 处理--第三方平台携带token跳转业务详情
      async handleLoginByToken() {
        // 获取URL携带参数，判断是否携带token
        // const params = tool.getUrlParams()
        const hash = window.location.hash
        const query = hash.split('?')[1]
        const paramsUrl = new URLSearchParams(query)

        // 把 params 转换为对象
        const params = Object.fromEntries(paramsUrl)

        if (params.auth_token) {
          localStorage.removeItem('VALIDATION_USER_LOGIN_ACCOUNT')
          localStorage.removeItem('thirdLogin')
          if (this.$route.path.length > 1) {
            localStorage.setItem('loginLink', location.href)
          }
          localStorage.setItem(
            'requestHeader',
            JSON.stringify({
              TOKEN: params.auth_token,
              CLIENT_FLAG: 0,
              CLIENT_ID: 'XXXOOO',
              CLIENT_VERSION: 'win7'
            })
          )
          localStorage.setItem('SOURCE', params.source || '')
          // 缓存附件图片的ip地址信息
          localStorage.setItem('pictureAttachmentDomain', baseURL)

          if (params.id) {
            await this.switchToCompanyById(params.id)
          }

          // 调用接口替换当前登录信息存储
          employee.queryInfo('auth_token', null, queryInfoRes => {
            this.showRouteView = true
            // 立刻清 URL（防止泄露 / 刷新重复登录）
            // window.history.replaceState(null, '', window.location.origin + window.location.pathname)

            // 根据应用参数跳转目标页，并携带要打开的模块参数/详情参数，还有列表查询条件？
            if (params.approval_data_id) {
              setTimeout(() => {
                this.$router.push({
                  name: 'Approval',
                  params: params
                })
              }, 1000)
            }
          })
        }
      },

      // 切换公司
      async switchToCompanyById(companyId) {
        const res = await HTTPServer.companyLogin({ company_id: companyId }, 'Loading')
        localStorage.setItem(
          'requestHeader',
          JSON.stringify({
            TOKEN: res.token,
            CLIENT_FLAG: 0,
            CLIENT_ID: 'XXXOOO',
            CLIENT_VERSION: 'win7'
          })
        )
        localStorage.setItem('packageDeadline', JSON.stringify(res.endTime))
        const obj = {
          perfect: res.perfect,
          isCompany: res.isCompany,
          firstLogin: res.firstLogin
        }
        if (res.term_sign === '0') obj.term_sign = res.term_sign
        localStorage.setItem('perfect', JSON.stringify(obj))
        localStorage.setItem('historyTagRecordList', '')
        localStorage.setItem('cenjiPreviewList', '')
      }
    }
  }
</script>

<style lang="scss">
  @import '@/../common/scss/dialog-12.4.6.scss'; // 全局 dialog 弹窗样式
</style>

<style>
  #app {
    height: 100%;
  }
  .img-attr-dialog {
    position: absolute;
    z-index: 999999;
    top: 60px;
    left: 6px;
  }
  .img-attr-dialog .iconfont {
    font-size: 13px;
  }
  .img-attr-dialog .el-button {
    height: 28px;
    padding: 8px 15px 6px;
  }
</style>
